import { parseColors } from './colors';
import { generateImage } from './images';
import { parseProductCardSplashes } from './splashes';

const parseSingleItemData = (hasSingleItemData, {
    sizes,
    colors,
    quantity,
    status
}) => {
    if (hasSingleItemData) {
        return {
            colorValue: colors?.[0]?.value ?? null,
            colorName: colors?.[0]?.name ?? null,
            size: sizes?.[0] ?? null,
            quantity,
            status
        };
    }

    return null;
};

export const generateVariantUrl = (productUrl, eanId) => `${productUrl}/${eanId}`;

const parseThumbnail = ({
    thumb,
    product,
    imagesParameters,
    cardConfig,
    colors
}) => {
    const {
        sizes,
        id,
        ean_id: eanId,
        text_splashes: textSplashes,
        image_splash: imageSplash,
        quantity,
        status,
        media
    } = thumb;

    const { product_url: productUrl } = product;

    const { hasSingleItemData, styleFlex = {} } = cardConfig;

    const image = media?.find(({ type }) => type === 'image');

    return {
        img: image ? generateImage(imagesParameters, image, styleFlex) : {},
        sizes,
        variantId: id,
        eanId,
        // TODO: This is working, but i'm missing data from backend to generate the correct one
        url: generateVariantUrl(productUrl, eanId),
        splashes: parseProductCardSplashes(textSplashes, imageSplash, cardConfig),
        singleItemData: parseSingleItemData(hasSingleItemData, {
            sizes, colors, quantity, status
        })
    };
};

export const parseProductThumbnailsAndColors = (product, cardConfig) => {
    const { variants } = product;
    const {
        showColors,
        colorSwatches,
        imagesParameters
    } = cardConfig;

    const colors = [];
    const thumbnails = [];

    variants.forEach((variant) => {
        const {
            id: variantId,
            swatch_id: swatchId,
            color_name: colorName
        } = variant;

        if (showColors && !!swatchId) {
            colors.push({
                uniqueId: variantId,
                ...parseColors(swatchId, colorName, colorSwatches)
            });
        }

        thumbnails.push(parseThumbnail({
            thumb: variant,
            product,
            imagesParameters,
            cardConfig,
            colors
        }));
    });

    return {
        colors,
        thumbnails
    };
};
